<template>
  <div id="privacy-view">
    <menu-bar></menu-bar>
    <section class="bg-privacy">
    <main>
      <div class="container-fluid px-0">
        <img src="@/assets/img/professionals-cover.webp" class="img-fluid" alt="" />
        <!-- <h5 class="pt-3">Content Creation</h5> -->
      </div>
      <section class="my-5">
        <div class="container">
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >Aixperia Privacy Statement</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Updated: January 28, 2021</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Protecting your privacy is important to Aixperia. This Privacy Statement
              explains how Aixperia processes personal data collected through websites,
              products, and services (&ldquo;applications&rdquo;), including those
              distributed by our resellers and other channel partners, and through
              in-person and digital events, webinars, surveys, marketing activities, and
              visits to our premises (along with applications, collectively our
              &ldquo;offerings&rdquo;). References to&nbsp;</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&ldquo;Aixperia,&rdquo; &ldquo;we,&rdquo; or &ldquo;our&rdquo; means
              Aixperia, Inc. and other entities that belong to the Aixperia corporate
              family and that link to this Privacy Statement</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >.&nbsp;</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We may display supplemental privacy notices on occasion, such as when we
              believe additional transparency would help you make an informed choice about
              whether to provide personal data. For example, you may see a supplemental
              privacy notice explaining a particular data collection program, or you may
              see a supplemental privacy notice when registering for an event.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >This Privacy Statement describes how we process personal data for our own
              purposes.&nbsp;</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We also process personal data on behalf of our customers subject to a
              written contract</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >. We do not control the data processing or protection practices of our
              customers, which may differ from those set out in this Privacy
              Statement.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&ldquo;Personal data&rdquo; is information that identifies, or can
              reasonably be linked directly or indirectly to, an identifiable person.
              Personal data does not include information that is anonymous, de-identified,
              or aggregated, as those terms may be defined under applicable law. For
              purposes of this Privacy Statement, &ldquo;personal data&rdquo; and
              &ldquo;personal information&rdquo; have the same meaning and are used
              interchangeably.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >What Information Does Aixperia Collect About You?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We obtain personal data in different ways. Some personal data is collected
              directly from you. Other data is automatically collected or generated about
              how, when, and why you interact with us through our offerings, including
              data obtained through the use of cookies and other tracking technologies. We
              also obtain personal data about you from third parties.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span
                style="font-size: 16px; font-family: 'Arial', sans-serif; color: #2a2a2a"
                >Information you provide us:</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We collect information directly from you, such as when you sign up for an
              account or use our offerings, register a product or service, sign up for our
              newsletter or for one of our events, interact with one of our events,
              surveys, activities or with social media, visit our premises, or otherwise
              contact us. The types of information we may collect from you include:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Identifiers,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your name, telephone number, physical and/or email
                addresses, IP address, account username, and account password.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Professional information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your occupation, industry, professional licenses, work
                experience and employment history, and other qualifications.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Commercial information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as details about your subscription plans, the offerings that
                you have purchased, used and/or expressed interest in, and events you have
                attended.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Financial account information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as payment information you provide when making a purchase of
                or through an offering (a third party processes these transfers on our
                behalf as described below).</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Education information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your educational background.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Protected characteristics,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your date of birth (where applicable).</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Visual, audio, and electronic information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your picture or signature; records of our interactions,
                such as correspondence, details of complaints and their resolutions,
                service records; your preferences, including your preferred tools,
                experience, language, and the frequency at which you wish to receive
                marketing communications.</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >When you make purchases through our websites, we use payment processors
              (&nbsp;</span
            ><span style="color: black"
              ><a href="https://stripe.com/us/privacy" target="_blank"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #70ad47;
                    "
                    >Stripe</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >) and do not store credit card or other financial information (other than
              confirmation that payment in a certain amount has been made). We collect
              contact and account information from you that we pass through to the payment
              processor to facilitate the transaction. For more information you can
              contact our providers as set forth in their privacy notices.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span
                style="font-size: 16px; font-family: 'Arial', sans-serif; color: #2a2a2a"
                >Information we obtain or generate:</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We automatically collect or generate certain personal information about you
              based on your interactions with us, such as when your use our offerings, and
              we may associate that information with your account. The information we
              collect includes:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Identifiers,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as unique user identifiers, unique device identifiers, IP
                addresses, cookie identifiers, information about product licenses, and
                usernames.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Internet or other electronic network activity information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as the website domain visited; which activities and offerings
                are used, how, and for how long; posts, discussions, and other types of
                engagement with us, including on our blogs, discussion forums, or chat
                rooms; the use of any hyperlinks or downloadable content available through
                the offerings.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Geolocation information</span
                ></strong
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Electronic information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as information about operating systems, device types,
                information about browsers, information relating to automatic updates and
                technical errors, information about your use of our offerings, including
                your preferred tools and experiences, and your engagement with our
                activities.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Commercial information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as records about interest in our offerings or completed
                purchases.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Identifying characteristics</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as facial templates and eye movement.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Inferences</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;drawn from any of the personal and offering usage information
                available to us.</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We also use cookies (small text files stored by your web browser when you
              use websites) and related technologies, such as pixels and beacons
              (collectively &ldquo;Cookies&rdquo;), to collect and store information when
              you use our applications. We use
              <a href="https://www.autodesk.com/company/autodesk-analytics"
                ><strong
                  ><span style="color: #2a2a2a">Aixperia Analytics programs</span></strong
                ></a
              >
              and tools that incorporate third-party analytics tools, such as&nbsp;</span
            ><span style="color: black"
              ><a href="http://www.google.com/policies/privacy"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >Google Analytics</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >, to help us understand how, when and why you use our applications. To
              learn more, see our&nbsp;</span
            ><span style="color: black"
              ><router-link to="/cookie-policy"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >Cookie Statement</span
                  ></strong
                ></router-link
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Except as described in our Privacy Statement and our Cookie Statement,
              whether we collect data through the use of Cookies is up to you. You can
              change your mind at any time by going into your Settings within the
              application or by clicking a link in the footer of our websites. The
              relevant link may be titled &ldquo;Cookie preferences,&quot; &ldquo;Privacy
              settings,&rdquo; or something similar.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Cookie choices are generally application-, browser-, and device-specific,
              so you may need to refresh your choices if you visit a different
              application, use a new browser or device, or clear your browser&rsquo;s
              cookies.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span
                style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
                >Social Networking Data:</span
              ></strong
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&nbsp;We may include content, pixels, tags, buttons, or other tools that
              link to another company&rsquo;s services and/or platform(s)
              (&ldquo;Plugins&rdquo;). If you use one of our offerings that contains
              Plugins, information can be transferred directly from your device to a
              third-party provider of services and/or platforms. We may not control the
              data collected by Plugins. If you are logged in to a social network, the
              social network may be able to link your use of our offering to their
              services and/or platform.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >For example, if you interact with a Plugin by clicking on &quot;Like,&quot;
              &quot;Follow,&quot; or &quot;Share,&quot; or by writing a comment, this
              information may automatically appear in your profile on the relevant social
              network service or platform. Even if you are not logged in, the Plugins may
              send your IP address to social network services and/or platforms. Please
              note this when using our offerings.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >When you connect to a social networking service or platform on a device
              that is also used by others, these other users may be able to see
              information that is stored or displayed in connection with your profile on
              the social networking service page.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span
                style="font-size: 16px; font-family: 'Arial', sans-serif; color: #2a2a2a"
                >Information we collect from other parties:</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We receive and process information from our affiliates and from third-party
              sources, such as employers, business partners, business contact databases,
              enrichment services, channel partners (e.g. resellers), marketing service
              providers, third-party data aggregators, and social networking services and
              platforms (e.g., LinkedIn and Facebook). We also receive information from
              publicly available sources and licensors. The categories of personal
              information we collect from these sources include:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Identifiers,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as names, phone numbers, and email addresses.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Professional information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as occupations, industries, professional licenses, work
                experience and employment histories, and other qualifications.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Education information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as your educational background.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Commercial information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as events you have attended or activities you have
                participated in.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Inferences,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as regarding usage information and your preferences,
                behaviors, and other attributes.</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >In accordance with applicable law, we may combine your personal data with
              information we collect from other parties to help keep our databases current
              and accurate, and to provide you with more relevant content, experiences,
              applications, and other offerings.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >How Does Aixperia Use The Information It Collects About You?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We use your personal data mindfully, and in useful ways, including:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To validate your identity as necessary to perform our contract with
                you.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To deliver services, products, and other offerings, including information
                such as personalized insights and recommendations, as necessary to perform
                our contract with you.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To send you important information, such as about your account or
                purchases, within the scope of our contract with you.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To send you information you requested to the extent necessary to perform
                our contract with you or, when not necessary to perform a contract, in
                furtherance of our legitimate interest, for example in responding to
                customer inquiries.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To maintain and improve the security of, and to troubleshoot any issues
                relating to, our offerings as necessary to perform our contract with you
                or, when not necessary to perform a contract, in furtherance of our
                legitimate interest in protecting our business.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To anonymize, aggregate, or de-identify your personal data so it can no
                longer identify you in furtherance of our legitimate interest in
                conducting research and analysis.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To develop and improve our current and future offerings and your
                experience, including through the use of automated systems that analyze
                data using machine learning and other analytic techniques, in furtherance
                of our legitimate interests or, where needed, with consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To understand the ways our offerings are used and who is using them in
                furtherance of our legitimate interest in improving our offerings and the
                overall user experience or, where needed, with consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To analyze information about how you interact or may interact with us or
                our offerings in furtherance of our legitimate interest in improving our
                offerings and your experience with us or, where needed, with
                consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To make strategic decisions concerning our business operations, including
                reporting on the performance of our business, in furtherance of our
                legitimate interest in making those decisions or, where needed, with
                consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To send you learning content, tutorials, suggestions, newsletters,
                surveys, or other information, including information that may be relevant
                to your interests or preferences, in furtherance of our legitimate
                interest in improving your customer experience or, where needed, with
                consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To send you promotional offers, advertising, or other marketing content
                in furtherance of our legitimate interest to engage in direct marketing
                or, where needed, with consent.</span
              >
            </li>
            <li
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To detect, prevent, or otherwise address non-valid use such as through
                fraud and software piracy (e.g., to confirm that software is genuine and
                properly licensed) and to protect you, Aixperia, and/or third parties in
                furtherance of our legitimate interests</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To enforce, and review compliance with, the legal terms that govern our
                offerings in furtherance of our legitimate interest in ensuring adherence
                to the relevant terms.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To comply with our legal obligations under applicable laws.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >To protect the rights, safety, and property of Aixperia, you, or any
                third party in furtherance of our legitimate interest in protecting us,
                our users, and third parties.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >For other purposes for which we obtain your consent.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >As further described in our offerings.</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Where we rely on your consent to process personal data, you may withdraw
              your consent at any time by contacting us at the contact details below or as
              otherwise indicated to you in writing.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Where we rely on our legitimate interests to process your personal
              information, we balance your rights against ours so that our interest is not
              overridden by the interests you have to protect your information.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >You may also have the right to object to that processing on the basis of
              circumstances specific to you. For more information, see &ldquo;</span
            ><span style="color: black"
              ><a href="#"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >What Rights and Choices Do You Have?</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&rdquo; below.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >When we process personal data about you to comply with legal requirements
              or to perform our obligations under a contract with you or with our customer
              through whom you use our offerings, failure to provide such data may prevent
              or delay our fulfillment of these obligations.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >How Does Aixperia Disclose Your Personal Data?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We disclose the categories of information described above to the following
              categories of persons:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Our service providers,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;including vendors, consultants, and other service providers who
                perform services or functions on our behalf, for business purposes. For
                example, our service providers include companies who support us with
                marketing, sales, consulting, communications, software maintenance and
                support, analytics, social media, market research, auditing for valid use,
                license compliance, security, user verification, localization,
                &nbsp;payment processing&nbsp;</span
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >and Third party software and SAAS service provider</span
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;. Our service providers process your information subject to
                contractual terms that restrict their ability to use your
                information.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Our business partners,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as integration partners, channel partners (e.g., resellers),
                event sponsors, partners, and attendees, Ad Partners, and Aixperia&rsquo;s
                App Store publishers, with whom you interact to facilitate your
                relationship with Aixperia and those business partners for any of the
                purposes described in our or those business partners&rsquo; privacy
                statements.</span
              >
            </li>
            <li
              style="
                margin-top: 0cm;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Our affiliates,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;for any of the purposes and uses of information described in this
                Privacy Statement, including providing you with integrated offerings
                (including administering purchases, services, and payments across our
                integrated offerings) in furtherance of our legitimate
                interests.&nbsp;</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Social networking services and platforms</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;to connect with or share information publicly, with service
                providers, or with your contacts on such services or platforms.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Persons to whom we are required by law to provide information,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;such as pursuant to a subpoena or a court order.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Law enforcement, legal counsel, or other reasonably necessary
                  parties</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;when we have a good faith belief that the disclosure is necessary
                to prevent or respond to fraud or software piracy, defend ourselves
                against attacks, or protect the rights, property, and safety of Aixperia,
                our customers, and the public.</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <strong
                ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                  >Persons involved in the consideration, negotiation, completion of a
                  business transaction,</span
                ></strong
              ><span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >&nbsp;including the sale, merger, consolidation, acquisition, change in
                control, transfer of substantial assets, bankruptcy, or reorganization,
                and any subsequent integration.</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We may also disclose your personal information to other parties when we
              have your consent to do so or when you direct us to, for any purposes
              requested or permitted by you.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We may share aggregate, anonymous, or de-identified demographic,
              statistical, and other information regarding use of our offerings with third
              parties for marketing, analytics, planning, and other purposes. Such
              information will not specifically identify any particular user.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >How Does Aixperia Protect Your Data?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We maintain a combination of reasonable and appropriate physical,
              administrative, and technological controls to protect your data from
              unauthorized access or malicious actions.&nbsp;</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We take reasonable steps to limit the access employees, contractors, and
              agents of Aixperia have to your personal data to those who need to know this
              data to perform their assigned functions.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >What Rights And Choices Do You Have?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >You have the right to access, update, delete, receive a copy of, or
              restrict our use of your personal data. When we process personal data based
              on your consent, you have the right to withdraw consent any time.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Please log-in to your account to manage your personal data and content
              using our applications. You can also delete your personal data and close
              your account. We may retain certain data about you for legal and internal
              business purposes, such as fraud prevention, in accordance with applicable
              laws.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >To request a copy of the personal data in your account, please&nbsp;</span
            ><span style="color: black"
              ><a
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                    "
                    >submit this form</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #70ad47"
              >.&nbsp;</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Consistent with applicable law, we may ask for proof of your identity
              before fulfilling your request, and we may ask for additional forms of
              verification depending on the nature of the personal information
              requested.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Certain jurisdictions grant individuals additional rights with respect to
              their personal data. Depending on where you live or applicable law, you may
              also have the right to:</span
            >
          </p>
          <ul style="margin-bottom: 0cm; margin-top: 0cm" type="disc">
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Object to our processing of your personal data</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Have us block or anonymize your personal data, as appropriate</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Receive a copy of your personal data to transfer it to a third
                party</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Opt-out of certain direct marketing communications</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Opt-out of certain disclosures of your personal information to third
                parties</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 4.5pt;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Not be denied a good or service for exercising your rights, though you
                may be provided a different level of service or charged a different rate
                or price consistent with applicable law</span
              >
            </li>
            <li
              style="
                margin-top: 6pt;
                margin-right: 0cm;
                margin-bottom: 0cm;
                margin-left: 0cm;
                line-height: 1.6;
                font-size: 15px;
                font-family: 'Calibri', sans-serif;
                color: #3c3c3c;
                
              "
            >
              <span style="font-size: 16px; font-family: 'Arial', sans-serif"
                >Lodge a complaint with the relevant data protection authority in the
                jurisdiction in which you are located</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >These rights may be limited in some circumstances by local law. For
              example, even if you ask us to delete your personal information, we may need
              to retain it to complete transactions you have requested, to comply with our
              legal obligations, or for other limited business purposes as required or
              permitted by law. To exercise applicable rights, please&nbsp;</span
            ><span style="color: black"
              ><a href="mailto:talk@aixperia.com"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >contact us</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Where we process personal data on behalf of our customers, we may refer the
              request to the relevant customer and cooperate with their handling of the
              request, subject to any special contractual arrangement with that
              customer.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >What Are Aixperia&rsquo;s Storage And Data Retention Practices?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We store your personal data and content on our servers and the servers of
              our service providers. Because we and our service providers maintain servers
              in global locations, your personal data may be transferred across national
              borders and stored on the servers outside of your country or region.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We will retain your personal data for as long as necessary to provide you
              with the offerings that you are using or have requested, for the
              establishment, exercise or defense of legal claims, and as needed to comply
              with our legal obligations. Data may persist in copies made for backup and
              business continuity purposes for additional time.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >Does Aixperia Transfer Your Personal Data Across National Borders?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Because we are a global company, we transfer personal data across national
              borders to other countries, in compliance with the laws that apply to that
              data. Where required by law, we have put in place measures (such as standard
              contractual clauses) to adequately protect personal data that we transfer
              across borders. If you wish to obtain a copy of the safeguards that we use
              to protect personal data transferred across borders, please contact us using
              the information in the &ldquo;How to contact us&rdquo; section below.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >What Are Aixperia&rsquo;s Marketing And Advertising Practices?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We use analytics tools and also work with one or more advertising networks
              (our &ldquo;Ad Partners&rdquo;) that use Cookies or other technologies to
              collect information about application visitors, to serve ads, and to help us
              track results of advertising and marketing campaigns. Through these means,
              we and/or our Ad Partners may be able to collect information from
              application visitors, including websites visited, how, when and why
              applications are used, marketing preferences, IP addresses, device IDs, and
              information about browsers. This information is used to display personalized
              advertising in websites and other applications, to calculate and control the
              number of unique and repeat views of a given ad, to deliver ads that relate
              to a visitor&rsquo;s interests, and to measure the effectiveness of ad
              campaigns. We process your personal data for the above activities in
              furtherance of our legitimate interests or, where required, with your
              consent.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >You can opt out of the use of your information by Ad Partners for online
              behavioral advertising by using the Digital Advertising
              Alliance&rsquo;s&nbsp;</span
            ><span style="color: black"
              ><a href="#"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >Your AdChoices</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&nbsp;tool. The Your AdChoices tool may not work if your browser does not
              accept third-party Cookies, and if you delete Cookies, use a different
              browser, or use a different computer, you will need to use the tool again to
              renew your opt out.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >As described above, you can change your Cookie preferences. Cookie choices
              are generally application-, browser-, and device-specific, so you may need
              to refresh your choices if you visit a different application, use a new
              browser or device, or clear your browser&rsquo;s cookies.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >Aixperia currently does not respond to &ldquo;do not track&rdquo;
              signals.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >Is The Personal Data You Give Us Ever Displayed Publicly?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >As always, we urge you to be mindful when deciding to disclose personal
              data, including on our offerings. Our offerings may allow you to post
              content, including comments and &ldquo;likes,&rdquo; that can be visible to
              the public.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >In some cases, you can limit who can view or access the information and
              content you post. In other cases, the information and content might be
              available to registered members of the offering, or even to the general
              public. Your name, username, profile image, or email address (particularly
              if this is your username) may be posted along with any message or other
              content you post through some of our offerings.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >If you are posting information you do not want to be disclosed publicly,
              make sure you are using an offering that allows you to control who sees
              information you have posted.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >Will This Privacy Statement Change?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We may change this Privacy Statement to reflect changes in the law, our
              data handling practices, or the features of our business. The updated
              Privacy Statement will be available at our&nbsp;</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; "
              >Website</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >. We will show the date the Privacy Statement was last updated to help you
              know when we change it. If we make material changes to our Privacy
              Statement, we will endeavor to provide you with notice before such changes
              take effect, such as through prominent notice on our website or services or
              by email.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >How To Contact Us?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >If you want to contact us, please use the following contact information.
              When you do so, please tell us the name of the offering about which you are
              contacting us:</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >By email at:&nbsp;</span
            ><span style="color: black"
              ><a href="mailto:privacy.questions@Aixperia.com"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >privacy.questions@Aixperia.com</span
                  ></strong
                ></a
              ></span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 9pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >By postal mail to:</span
            >
          </p>
          <p style="font-family: 'Calibri', sans-serif">
            Kerala Startup mission, <br/> 
            Kinfra Hi-Tech Park,<br/> 
            near Government Medical College,<br/> 
            Kalamassery, Kochi, Kerala 683503.
          </p>

          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span
                style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
                >Data protection officer:</span
              ></strong
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&nbsp;To contact our data protection officer, please use the following
              contact information:&nbsp;</span
            ><span style="color: black"
              ><a href="mailto:DPO@aixperia.com"
                ><strong
                  ><span
                    style="
                      font-size: 16px;
                      font-family: 'Arial', sans-serif;
                      color: #2a2a2a;
                    "
                    >DPO@Aixperia.com</span
                  ></strong
                ></a
              ></span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >.</span
            >
          </p>
          <p
            style="
              margin-top: 0cm;
              margin-right: 0cm;
              margin-bottom: 0cm;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <strong
              ><span style="font-size: 28px; font-family: 'Arial', sans-serif"
                >Who Can I Contact With Questions Or Concerns?</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 9pt;
              margin-right: 0cm;
              margin-bottom: 8pt;
              margin-left: 0cm;
              line-height: 1.6;
              font-size: 15px;
              font-family: 'Calibri', sans-serif;
              
            "
          >
            <span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >We are committed to working with you to obtain a fair resolution of any
              complaint or concern about privacy. If, however, you believe that we have
              not been able to assist with your complaint or concern, you have a right to
              lodge a complaint with the&nbsp;</span
            ><span
              style="
                font-size: 15px;
                font-family: 'Arial', sans-serif;
                color: #333333;
                
              "
              >&nbsp;Information Technology Act, 2000 (&quot;IT Act&quot;) and its
              ancillary rules, the Information Technology (Reasonable Security Practices
              and Procedures and Sensitive Personal Data or Information) Rules, 2011
              (&quot;IT Rules&quot;)&nbsp;</span
            ><span
              style="font-size: 16px; font-family: 'Arial', sans-serif; color: #3c3c3c"
              >&nbsp;and/or with a competent European supervisory authority or your local
              equivalent.</span
            >
          </p>
        </div>
      </section>
    </main>
    </section>
  </div>
</template>
<script>
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
  duration: 1000,
});
import MenuBar from "@/views/site/blocks/MenuBar";
export default {
  name: "PrivacyPolicy",
  components: { MenuBar },
};
</script>
<style scoped>
.pano-viewer .index-module__bottom-container {
  visibility: hidden !important;
  display: none !important;
}
</style>
